<template>
  <div class="good-shop" @click.stop="gotoShop">
    <span
      v-if="popShortName"
      :class="[
        'shop-name',
        {
          'shop-name-tip': !showTip
        }
      ]"
    >
      {{ popShortName }}
    </span>
    <span v-if="showTip && popShortName" class="shop-tip">进店</span>
    <IconFont v-if="popShortName" name="mc-icon-arrowright" size="6px" />
  </div>
</template>

<script>
export default {
  props: {
    popShortName: {
      type: String,
      default: ''
    },
    popUrl: {
      type: String,
      default: ''
    },
    showTip: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    gotoShop() {
      if (this.popUrl !== '') {
        this.$emit('goodShopTrack')
        this.$autoRedirect(this.popUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.good-shop {
  display: flex;

  height: 0.36rem;
  margin-top: 0.08rem;

  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #595959;
  .shop-tip {
    display: inline-block;

    max-width: 0.7rem;
    margin-left: 0.16rem;

    color: #595959;
  }
  .shop-name {
    display: inline-block;

    max-width: calc(100% - #{0.95rem});

    color: #8c8c8c;
    @include text-overflow-ellipsis-single;
    &-tip {
      max-width: calc(100% - #{0.2rem});
    }
  }
}
</style>
